module.exports = __webpack_public_path__ + "/bundle/asset/U2_01-579f7f5b2106c0e55ba49d2b8926d67a.gif";